// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"537":"9a550532","660":"03c3e641","886":"845e5e7d"}[chunkId] + ".chunk.css";
};